import angular from 'angular';

import process from './process';
import processesDirective from './processes.directive';


export default angular.module('app.components.advisory.enterpriseModeling.processes', [
  process
])
  .directive('emProcesses', processesDirective)
  .controller('ProcessesController', () => { /* here to provide controllerAs vm */ })
  .name;

console.log('app.components.advisory.enterpriseModeling.processes created');
